/* ══════════════════════════════════════════════════════════════════════
   PREVIOUS CYCLE — list rows.

   Both cycles are served by their own endpoint now (see
   fetchPagPreviousCycleList in api/frameworksApi) and return the identical
   row shape, so what is left here is the one rule that differs between
   them: how a past cycle reports completion.

   Unlike the current cycle, a past cycle is read-only history — it reports
   how a review finished (completed vs still pending) rather than offering
   Remove / Continue.
   ══════════════════════════════════════════════════════════════════════ */

import type {
  PagCycleListResponse,
  PagCycleListRow,
} from "../../../../api/frameworksApi";

/* Both cycles return the identical row shape, so the previous cycle reuses
   the current cycle's type rather than declaring a near-duplicate. */
export type PagPreviousCycleApiRow = PagCycleListRow;
export type PagPreviousCycleResponse = PagCycleListResponse;

/** A row is "completed" once it has been actioned either way, so completed
 *  = remove + continue. Falls back to total - pending when those are
 *  absent, so a partial payload still renders something truthful. */
export const completedCount = (r: PagPreviousCycleApiRow): number => {
  const actioned = (r.removeStatusCount ?? 0) + (r.continueStatusCount ?? 0);
  if (actioned > 0) return actioned;
  return Math.max(0, (r.totalStatusCount ?? 0) - (r.pendingStatusCount ?? 0));
};
